import {DeserializedRecord, deserializeItem, Deserializer, JSONAPIRecord} from "./Helpers";

interface StartContentMedia extends  DeserializedRecord<"saniq_start_content_media"> {
  name: string;
  alternativeText: string;
  width: number;
  height: number;
  url: string;
}

interface StartContent extends DeserializedRecord<"saniq_start_content"> {
  display: string,
  title: string;
  description: string;
  externalLink?: string;
  externalLinkText?: string;
  locale: string;
  platform: string;
  tenant?: string;
  media?: StartContentMedia[];
  loginFormIcon?: StartContentMedia;
}

interface StartContentData extends JSONAPIRecord {
  attributes: {
    media: {
      data: JSONAPIRecord[]
    },
    loginFormIcon: {
      data: JSONAPIRecord
    }
  }
}

const deserializeStartContent: Deserializer<StartContent, StartContentData> = (data) => {
  const media = data.attributes.media.data ?
    data.attributes.media.data.map((dataEntity) => deserializeItem<StartContentMedia>(dataEntity))
    :
    [];

  const loginFormIcon = data.attributes.loginFormIcon?.data ?
    deserializeItem<StartContentMedia>(data.attributes.loginFormIcon.data) : null;

  return {
    ...deserializeItem(data),
    media,
    loginFormIcon
  };
};

export {
  deserializeStartContent,
  StartContent
};
